import React from "react";
import "./com_3.css";
// import astrologyImage from "../assets/a91ea3b3-f932-44e4-8b4d-03a585d80c42.png"; // adjust path as needed

const CimImageSection = () => {
  return (
    <section className="cim-image-section">
      <div className="cim-image-container">
        <img
          src="/assets/joinusbanner.png"
          alt="Astrology chart with crystals"
          className="cim-image"
        />
        {/* <div className="cim-image-text">
          <h2>Exploring the Mysteries of the Zodiac</h2>
          <p>
            Dive into the fascinating world of astrology and uncover the cosmic
            forces that shape our lives. From birth charts to planetary
            alignments, explore the symbols and patterns that guide your
            spiritual journey.
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default CimImageSection;
